import { Inject } from '@odinjs/odin';
import { FetchAPI, ToastService } from '@philips-internal/oswald-ui-components';
import { ToastLevel } from '@philips-internal/oswald-ui-constants';
import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { HttpService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';

import { FragmentNames } from '../../codegen';
import { Endpoint } from '../../constants/endpoints';
import ApprovalContext from '../../services/ApprovalService';
import ReportService, { UriResponse } from '../../services/ReportService';
import BaseController from '../BaseController';

interface ApprovalItem {
  fileDescription: string;
}

@Controller({ fragment: FragmentNames.APPROVALS_ATTACHMENTS_LIST })
class ApprovalsAttachmentsListController extends BaseController {

  @Inject('attachment-fetch-list')
    fetchList: FetchAPI;

  @OnMount('attachment-panel-content')
  onFragmentMount(): void {
    const { documentNumber, orderType } = ApprovalContext.get();
    this.fetchList.setParameters({ 
      documentSequence: documentNumber,
      documentType: orderType, 
    });
    this.fetchList.forceFetch();
  }

  @OnClick({ target: 'approval-attachment-card' })
  async onAttachmentCardClick(event: ClickEvent): Promise<void> {
    if (event) {
      const { fileDescription } = event.value as ApprovalItem;
      try {
        const uriResponses: UriResponse = await HttpService.get(Endpoint.APPROVAL_FILE_URI, { uri: fileDescription });
        if (uriResponses.body && uriResponses.body.fileContent) {
          const byteArray = ReportService.base64ToBytes(uriResponses.body.fileContent);
          ReportService.downloadFile(byteArray, this.extractFileName(fileDescription));
        }
      } catch (error) {
        ToastService.open({
          id: 'approval-disapprove-toast',
          dismissible: false,
          message: MessageService.translate('approval.file-not-found'),
          level: ToastLevel.ERROR,
          timeout: 5000,
        });
      }

    }
  }

  extractFileName(fullString: string): string {
    const lastIndex = fullString.lastIndexOf('-');
    return fullString.substring(lastIndex + 1);
  }
}

export default ApprovalsAttachmentsListController;
